import React, { FC, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { actions } from '@bt-react/store'
import setupActions from '../../dataStore/actions/setup'
import { State } from '../../dataStore/reducers/reducerType'
import { useParams } from 'react-router-dom'
import { CONTROLLER } from '../../dataStore/constants/roles'
import PresenterScreen from '../PresenterScreen'
import componentStyles from './ControlCentreMain.module.scss'
import UIDocumentDisplay from './UIDocumentDisplay'
import TalksControl from './TalksControl'
import SlidesControl from './SlidesControl'
import { selectors } from '@bt-react/store'
import apiGateway from '../../services/apiGateway'
import getEnvironment from '@bt-react/libs/getEnvironment'

const ControlCentreMain: FC = () => {
  const { roomname } = useParams<{ roomname?: string }>()

  const [isAdmin, setIsAdmin] = useState(false)
  const uiStoreState = useSelector((state: State) => state.ui)
  const storeRoomname = useSelector((state: State) => state.config.roomname)
  const storeRole = useSelector((state: State) => state.config.role)
  const syncUi = useSelector((state: State) => state.syncUi)
  const channelId = useSelector((state: State) => state.config.channelId)
  const webcastId = useSelector((state: State) => state.config.webcastId)
  const presentersInRoom = useSelector((state: State) => state.room.presenters)
  const slides = useSelector((state: State) => state.slides)

  const dispatch = useDispatch<any>()

  const presentersInRoomArray: string[] = []

  for (const [key, value] of presentersInRoom) {
    presentersInRoomArray.push(value.name)
  }

  if (!storeRoomname) dispatch(setupActions.setRoomname(roomname))
  if (!storeRole) dispatch(setupActions.setRole(CONTROLLER))
  dispatch(actions.user.fetchUserData())
  dispatch(setupActions.joinRoom())
  if (channelId && webcastId) dispatch(actions.fetchPublicWebcastData(channelId, webcastId))

  const date = useSelector((state: State) => selectors.selectWebcast(state, `${state.config.channelId}${state.config.webcastId}`)['start'])
  const title = useSelector((state: State) => selectors.selectWebcast(state, `${state.config.channelId}${state.config.webcastId}`)['title'])
  const webcastURL = useSelector((state: State) => selectors.selectWebcast(state, `${state.config.channelId}${state.config.webcastId}`)['url'])

  useEffect(() => {

    if (getEnvironment().domain === 'localhost') {
      setIsAdmin(true)
      return
    }

    const result = async () => {
      try {

        await apiGateway.getCheckAdminRights()
        setIsAdmin(true)
      }
      catch( e) {

        console.log('here is the error: ', e)
        setIsAdmin(false)

      }
    }

    result()
  }, [isAdmin])

  return (isAdmin ? <div className={componentStyles['control-centre-container']}>
    <h1>Talks Command Control Centre</h1>
    <div className={componentStyles['control-centre-container-main']}>
      <div className={componentStyles['presenter-screen']}>
        <PresenterScreen />
      </div>
      <div className={componentStyles['talks-control']}>
        <TalksControl
          roomname={roomname}
          isLiveReady={uiStoreState.isLiveReady}
          isLive={uiStoreState.isLive}
          date={date}
          title={title}
          webcastURL={webcastURL}
          participantInfo={syncUi.participantInformation}
          muted={syncUi.mute}
          videoDisplay={syncUi.videoDisplay}
          presentersInRoom={presentersInRoomArray}
        />
      </div>
      <div className={componentStyles['slides-control']}>
        <SlidesControl
          slidesId={slides.activeDeck}
          talkId={roomname}
          slidesDeck={slides.slideDecks[0]}  />
      </div>
      <div className={componentStyles['ui-document-display']}>
        <UIDocumentDisplay />
      </div>
    </div>
  </div> :
  <h1>This page can only be accessed by a user with admin rights.</h1>
  )
}

export default ControlCentreMain